import { create } from 'zustand';

/**
 * The class a teacher's screen is working in, for the top bar to name.
 *
 * The top bar used to list every subject the teacher takes anywhere —
 * "english, mathematics, physics" — while the screen below offered only the
 * one they take in the class picked under Active Class, and the two read as a
 * contradiction. A screen with a class picker publishes its pick here; the top
 * bar shows that class and its subjects instead, and falls back to the full
 * list on every screen that has no pick to publish.
 */
interface HeaderClassState {
  /** "Class 9 - A · English", or null when no screen has a class picked. */
  label: string | null;
  setLabel: (label: string | null) => void;
}

export const useHeaderClass = create<HeaderClassState>((set) => ({
  label: null,
  setLabel: (label) => set({ label }),
}));
